import * as types from "../../actions/systemlevel/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_SYMMETRY_TAX_CODE_LIST:
      return action.payload;
    default:
      return state;
  }
}
